import { Component, OnInit } from "@angular/core";

import { DialogService } from "../../../common/services/dialog.service";
import { FlowTemplateService } from '../../services/flow-template.service';
import { LoaderService } from "../../../common/services/loader.service";
import { SidePanelService } from "../../../common/services/side-panel.service";

import { EntityMap } from "../../models/entity.model";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";

@Component({
    selector: "app-workflow-entity-import",
    templateUrl: "./workflow-entity-import.component.html",
    styleUrls: ["./workflow-entity-import.component.scss"],
    providers: [DialogService],
    standalone: false
})
export class WorkflowEntityImportComponent extends SidePanelBase implements OnInit {

  static componentName = "WorkflowEntityImportComponent";
  public errors: string[] = [];
  public files: any[];
  public parsedMaps: EntityMap[];
  public uploadFileName: string = "";

  constructor(
    public readonly templateService: FlowTemplateService,
    public readonly sidePanelService: SidePanelService,
    public readonly loader: LoaderService,
    public readonly dialogService: DialogService
  ) {
    super();
  }

  ngOnInit() {

  }

  public fileChanged(files): void {
    this.errors = [];
    if (!files || files.length === 0) return;
    const fileName = files[0].name;
    const nameParts = fileName.split(".");
    if (nameParts[nameParts.length - 1] !== "json") {
      this.errors.push("Invalid File Extension");
    }
    if (files[0].type !== "application/json") {
      this.errors.push("Invalid File Type");
    }
    if (this.errors.length !== 0) return;
    this.uploadFileName = `:${fileName}`;
    this.files = files;
    this.loader.toggleLoader(true);
    this.templateService.importEntityMaps(files[0]).subscribe((result) => {
      this.parsedMaps = result;
      this.loader.toggleLoader(false);
    }, (error) => {
      this.reset();
      this.errors.push(error.error);
      this.loader.toggleLoader(false);
    });

  }

  public reset(): void {
    this.uploadFileName = "";
    this.files = [];
    this.errors = [];
    this.parsedMaps = [];
  }

  public saveImportedMaps(): void {
    this.dialogService.openDialog("yesNo", "This will replace any existing maps with those in the imported file.  Once complete, this operation is irreversible without exiting the form builder without saving.  Do you wish to continue?");
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    this.saveMethod.emit(this.parsedMaps);
    this.reset();
    this.sidePanelService.toggleSidePanel(false);
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
    console.log("Save cancelled");
  }

}
